import { render } from "./ProductOutboxQueueListTableHeader.vue?vue&type=template&id=31532622"
import script from "./ProductOutboxQueueListTableHeader.vue?vue&type=script&lang=js"
export * from "./ProductOutboxQueueListTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__